import PerformanceOverview from 'containers/Performance/Perf';
import TemplatePerformance from 'containers/Performance/TemplatePerf';
import { addComponentsToRoutes } from 'services/common';
import routes from './routesOnNav';
import EnochPerf from '../../containers/Performance/EnochPerf';
import CSVPerformance from 'containers/Performance/CSV';
import SentEmailHistory from '../../containers/Performance/SentEmailHistory';

const components = {
  '/performance/overview': PerformanceOverview,
  '/performance/templates/:templateId?/:templateName?': TemplatePerformance,
  '/performance/enoch': EnochPerf,
  '/performance/csv': CSVPerformance,
  '/performance/history': SentEmailHistory,
};

export default addComponentsToRoutes(routes, components);
